<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <ul class="navigation-tabs">
        <slot />
    </ul>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    provide() {
        return {
            color: () => this.color,
            size: () => this.size
        };
    },

    props: {
        color: {
            type: String as PropType<"primary" | "secondary" | "tertiary">,
            validator(value: string) {
                return ["primary", "secondary", "tertiary"].includes(value);
            }
        },
        size: {
            type: String as PropType<"small">,
            validator(value: string) {
                return ["small"].includes(value);
            }
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.navigation-tabs {
    display: block;
    font-size: 0;
    list-style: none;
}
</style>
